export default {
  computed: {
    vehicleSelectionTarget() {
      return this.$store.getters.vehicle_selection_target
    },
  },

  methods: {
    clearVehicleSelectionTarget() {
      if (this.vehicleSelectionTarget) {
        this.$store.dispatch('setVehicleSelectionTarget', null)
      }
    },

    consumeVehicleSelectionTarget(vehicle) {
      if (!this.vehicleSelectionTarget || !vehicle?.id) return false

      this.$store
        .dispatch('applyVehicleSelectionTarget', vehicle)
        .then(applied => {
          if (applied) {
            this.$root.$emit('cart-vehicles-updated')
          } else {
            this.$swalErrorCustomMessage(
              this.$t('mixins.vehicleSelectionTargetMixin.associationError')
            )
          }
        })

      return true
    },
  },
}
